import request from '@/network/http';
import axios, { AxiosResponse } from 'axios';

export function deleteOrganizationInfo(data) {
    return request({
        url: 'Organization/Organization/deleteOrganizationInfo',
        method: 'post',
        data
    })
}

export function getOrganizationDetail(data) {
    return request({
        url: 'Organization/Organization/getOrganizationDetail',
        method: 'post',
        data
    })
}

export function saveOrganizationInfo(data) {
    return request({
        url: 'Organization/Organization/saveOrganizationInfo',
        method: 'post',
        data
    })
}

export function getOrganizationTypeList() {
    return request({
        url: 'Base/Organization/getOrganizationTypeList',
        method: 'post',
    })
}

export function getOrganizationTreeListByType(data) {
    return request({
        url: 'Organization/Organization/getOrganizationTreeListByType',
        method: 'post',
        data
    })
}

export function getOrganizationList(data) {
    return request({
        url: 'Organization/Organization/getOrganizationList',
        method: 'post',
        data
    })
}

export function getRegionTreeList() {
    return request({
        url: 'Base/Region/getRegionTreeList',
        method: 'post',
    })
}

export function getInvestigationLevelList(data) {
    return request({
        url: 'Base/Checkup/getInvestigationLevelList',
        method: 'post',
        data
    })
}

export async function saveOrgInfo(data) {
  const url = "http://47.100.218.108:8081/api/province/search/addRegion"
  const results = await axios.get(url, { params: data })
  if (results.data) {
    return results.data;
  }
  if (results.data == 0) { 
    return 0;
  }
  return results;
}

export async function getPosition(data) {
  const url = "http://47.100.218.108:8081/api/province/search/findById"
  const results = await axios.get(url, { params: data })
  if (results.data) {
    return results.data._embedded.province[0];
  }
  if (results.data == 0) { 
    return 0;
  }
  return results;
}




// WEBPACK FOOTER //
// ./src/apis/organlist.js